import { Type, type Static } from "@sinclair/typebox";
import { PageDocumentViewExecutionInputSchema } from "./common.ts";
import {
  RecentDocumentsViewCreateInputSchema,
  RecentDocumentsViewResultSchema,
  RecentDocumentsViewSchema,
  RecentDocumentsViewUpdateInputSchema
} from "./recent-documents.ts";
import {
  TimelineDocumentViewCreateInputSchema,
  TimelineDocumentViewResultSchema,
  TimelineDocumentViewSchema,
  TimelineDocumentViewUpdateInputSchema
} from "./timeline.ts";

export * from "./common.ts";
export * from "./recent-documents.ts";
export * from "./timeline.ts";

export const DocumentViewSchema = Type.Union([
  RecentDocumentsViewSchema,
  TimelineDocumentViewSchema
]);
export type DocumentViewV2 = Static<typeof DocumentViewSchema>;

export const DocumentViewCreateInputSchema = Type.Union([
  RecentDocumentsViewCreateInputSchema,
  TimelineDocumentViewCreateInputSchema
]);
export type DocumentViewCreateInputV2 = Static<typeof DocumentViewCreateInputSchema>;

export const DocumentViewUpdateInputSchema = Type.Union([
  RecentDocumentsViewUpdateInputSchema,
  TimelineDocumentViewUpdateInputSchema
]);
export type DocumentViewUpdateInputV2 = Static<typeof DocumentViewUpdateInputSchema>;

export const DocumentViewExecutionInputSchema = Type.Union([PageDocumentViewExecutionInputSchema]);
export type DocumentViewExecutionInputV2 = Static<typeof DocumentViewExecutionInputSchema>;

export const DocumentViewResultSchema = Type.Union([
  RecentDocumentsViewResultSchema,
  TimelineDocumentViewResultSchema
]);
export type DocumentViewResultV2 = Static<typeof DocumentViewResultSchema>;
